import { useEffect, useState } from 'react'

import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const workExperience = [
  {
    id: 1,
    company: 'Nagarro',
    companyUrl: 'https://www.nagarro.com/',
    position: 'Staff Engineer',
    duration: 'May 2022 – Present',
    location: 'Mumbai, India',
    achievements: [
      'Led technical design and development of enterprise-grade applications using Java, Spring Boot, and microservices architecture.',
      'Served as Tech Lead on multiple projects, designing and developing various modules while facilitating scrum meetings.',
      'Mentored team members and guided them in best practices for Java Full Stack development and AI integration.',
      'Worked on projects involving AI technologies including Spring AI, Langchain, and CrewAI for intelligent system development.'
    ]
  },
  {
    id: 2,
    company: 'Saint-Gobain',
    companyUrl: 'https://www.saint-gobain.com/',
    position: 'Tech Lead',
    duration: 'Oct 2017 – Apr 2022',
    location: 'Mumbai, India',
    achievements: [
      'Collaborated with IT Project Managers to develop focused plans and solutions for enterprise applications.',
      'Monitored team progress and ensured timely delivery of project goals and milestones.',
      'Gathered and analyzed requirements from onsite teams to design effective technical solutions.',
      'Led development of multiple modules and was recognized as part of the Talent pool program.'
    ]
  },
  {
    id: 3,
    company: 'Ebrandz Pvt. Ltd.',
    companyUrl: '#',
    position: 'Software Developer',
    duration: 'Sept 2015 – Oct 2017',
    location: 'Mumbai, India',
    achievements: [
      'Developed white label SaaS platforms and customer dashboards for SEO and PPC management using PHP and CodeIgniter.',
      'Built interactive web interfaces with HTML5, CSS3, and jQuery for real-time analytics and reporting tools.',
      'Created custom tools and dashboards enabling customers to manage SEO campaigns, keyword tracking, and PPC analytics.',
      'Implemented responsive web applications with dynamic data visualization for marketing analytics and performance metrics.'
    ]
  },
  {
    id: 4,
    company: '69 Productions Pvt. Ltd.',
    companyUrl: '#',
    position: 'Junior Developer',
    duration: 'Dec 2014 – Sept 2015',
    location: 'Mumbai, India',
    achievements: [
      'Developed bus fleet management system using PHP and CodeIgniter for tracking vehicles, routes, and scheduling operations.',
      'Built movie website with dynamic content management, show timings, and booking functionality using HTML, CSS, and jQuery.',
      'Created internal tools and administrative dashboards for managing business operations and data entry workflows.',
      'Implemented responsive web interfaces with interactive features using jQuery for enhanced user experience.'
    ]
  }
]

const Experience = () => {
  const experienceArray = 'Experience'.split('')
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container experience-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={experienceArray}
              idx={15}
            />
          </h1>
          <p>
            With 11 years of extensive experience in delivering IT solutions for 
            telecom, finance, and SEO domains, I have worked with various open-source 
            technologies to create industry-grade applications. My journey includes 
            leading technical teams, designing microservices architectures, and 
            implementing AI-powered solutions.
          </p>
        </div>

        <div className="experience-container">
          <div className="timeline">
            {workExperience.map((job, index) => (
              <div key={job.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-marker">
                  <FontAwesomeIcon icon={faBriefcase} />
                </div>
                <div className="timeline-content">
                  <div className="job-header">
                    <h3 className="company-name">
                      <a href={job.companyUrl} target="_blank" rel="noreferrer">
                        {job.company}
                      </a>
                    </h3>
                    <h4 className="position">{job.position}</h4>
                    <div className="job-meta">
                      <span className="duration">{job.duration}</span>
                      <span className="location">{job.location}</span>
                    </div>
                  </div>
                  <ul className="achievements">
                    {job.achievements.map((achievement, idx) => (
                      <li key={idx}>{achievement}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Experience
